<template>
  <div
    class="tw-flex tw-flex-col tw-justify-center tw-items-start tw-gap-[40px] tw-self-stretch tw-p-[40px] main__content"
  >
    <div
      class="tw-flex tw-items-start tw-flex-col tw-gap-[30px] headingWrapper"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="55"
        height="54"
        viewBox="0 0 55 54"
        fill="none"
      >
        <g clip-path="url(#clip0_8833_27353)">
          <path
            d="M27.163 2.25996C13.3992 2.25996 2.27877 13.2886 2.27877 26.9388C2.27877 40.589 13.3992 51.6176 27.163 51.6176C40.9267 51.6176 52.0471 40.589 52.0471 26.9388C52.0471 13.2886 40.9267 2.25996 27.163 2.25996ZM27.163 53.8776C12.2142 53.8776 0 41.7641 0 26.9388C0 12.1134 12.2142 0 27.163 0C42.1117 0 54.3259 12.1134 54.3259 26.9388C54.3259 41.7641 42.1117 53.8776 27.163 53.8776Z"
            fill="#211F58"
          />
          <path
            d="M35.184 28.2038C34.5459 32.091 31.1733 34.9837 27.1627 34.9837C22.6963 34.9837 19.0503 31.3678 19.0503 26.9382C19.0503 22.5087 22.6963 18.8928 27.1627 18.8928C31.1733 18.8928 34.5459 21.8759 35.184 25.6727L37.2804 24.4975C36.1866 19.9776 32.0848 16.6328 27.1627 16.6328C21.4202 16.6328 16.7715 21.2431 16.7715 26.9382C16.7715 32.6334 21.4202 37.2437 27.1627 37.2437C32.0848 37.2437 36.1866 33.8989 37.2804 29.379L35.184 28.2038Z"
            fill="#211F58"
          />
          <path
            d="M29.6234 11.3008L28.4384 13.3799C35.4571 14.0127 40.9261 19.8886 40.9261 26.9397C40.9261 34.4428 34.7279 40.5899 27.1623 40.5899C19.5968 40.5899 13.3986 34.4428 13.3986 26.9397C13.3986 19.8886 18.8676 14.0127 25.8862 13.3799L24.7013 11.3008C17.0446 12.476 11.2109 19.0751 11.2109 26.9397C11.2109 35.7084 18.4119 42.8499 27.2535 42.8499C36.0951 42.8499 43.296 35.7084 43.296 26.9397C43.2049 19.0751 37.2801 12.476 29.6234 11.3008Z"
            fill="#211F58"
          />
          <path
            d="M27.1626 5.51562C16.1334 5.51562 7.0183 13.7419 5.74219 24.4089L7.92981 25.6745C8.65902 15.7307 16.9537 7.86599 27.1626 7.86599C37.8273 7.77559 46.4866 16.3635 46.4866 26.9401C46.4866 37.5167 37.8273 46.1046 27.1626 46.1046C16.9537 46.1046 8.65902 38.2399 7.92981 28.2961L5.74219 29.5616C7.0183 40.1383 16.1334 48.3646 27.1626 48.3646C39.1034 48.3646 48.7654 38.7823 48.7654 26.9401C48.7654 15.0979 39.1034 5.51562 27.1626 5.51562Z"
            fill="#211F58"
          />
        </g>
        <defs>
          <clipPath id="clip0_8833_27353">
            <rect width="240.729" height="53.8776" fill="white" />
          </clipPath>
        </defs>
      </svg>
      <span
        class="tw-text-[#211F58] tw-text-[25px] tw-not-italic tw-font-semibold tw-leading-[100%]"
        >{{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-modal-title-welcome-1",
          )
        }}</span
      >
    </div>
    <div class="tw-w-full tw-h-full tw-flex tw-flex-col tw-gap-[25px] main">
      <div
        class="tw-flex tw-flex-col tw-gap-[5px] md:tw-gap-[10px] md:tw-flex-row tw-justify-between tw-items-start tw-self-stretch tw-rounded tw-px-[5px] md:tw-px-[25px] tw-py-[25px]"
      >
        <div class="left">
          <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-2.5 tw-px-0 info"
          >
            <span
              class="tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-leading-[100%] title__content"
              >{{
                getComponentUiText(
                  "app-menu-submenu-home-setup-wizard-modal-title-content-1",
                )
              }}</span
            >
            <span
              class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[145%]"
              >{{
                getComponentUiText(
                  "app-menu-submenu-home-setup-wizard-modal-content-1",
                )
              }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div style="margin: 0 auto; padding-bottom: 40px">
      <div
        v-if="isStatusApiSetup"
        :style="{ cursor: isStatusApiSetup ? '' : 'not-allowed' }"
        :class="`tw-select-none tw-cursor-pointer tw-flex tw-self-end tw-gap-2.5 tw-px-[20px] tw-py-[8px] tw-rounded-[26.909px]  ${
          isStatusApiSetup ? 'tw-bg-[#387DFF]' : 'tw-bg-[#C0C0C0]'
        } tw-text-white tw-text-center tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[100%] createBtn`"
        @click="getStarted"
      >
        {{
          getComponentUiText(
            "app-menu-submenu-home-setup-wizard-modal-btn-get-started-1",
          )
        }}
      </div>
      <div v-if="!isStatusApiSetup" class="tw-h-[45px] tw-w-[45px]">
        <LottieAnimation
          ref="anim"
          :animation-data="ProgressAnimation"
          :auto-play="true"
          :loop="true"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";

const currentOrg = computed(() => store.state.Org.currentOrg);
const isStatusApiSetup = computed(
  () => store.state.SetupWizard.isStatusApiSetup,
);

const isLoading = ref(false);

let anim = ref();
const emit = defineEmits(["update:state"]);
onBeforeMount(() => {
  anim.value;
});
onMounted(() => {
  store.commit("SetupWizard/SET_CURRENT_ORG", currentOrg.value.id);
});

watch(
  () => isStatusApiSetup.value,
  (value) => {
    if (value) {
      const questionsStore = store.state.SetupWizard.questions;
      const currentOrgQuestions =
        questionsStore[Object.keys(questionsStore)[0]];

      let hasData = false;
      Object.keys(currentOrgQuestions).forEach((key) => {
        if (["goals", "org", "services", "webservices", "misc"].includes(key)) {
          const questions = currentOrgQuestions[key];
          const hasValue = questions.some(
            (question) => question.values && question.values.length > 0,
          );
          if (hasValue) hasData = true;
        } else if (key === "domains") {
          const domainQuestions = currentOrgQuestions.domains;
          const hasDomainValue =
            domainQuestions[0].values.length > 1 ||
            domainQuestions[1].values.length > 0;
          if (hasDomainValue) hasData = true;
        } else if (key === "brands") {
          const brandQuestions = currentOrgQuestions.brands;
          const hasBrandValue = brandQuestions[0].values[0].brandName !== "";
          if (hasBrandValue) hasData = true;
        } else if (key === "sites") {
          const siteQuestions = currentOrgQuestions.sites;
          const hasSiteValue = siteQuestions[0].values[0].name !== "";
          if (hasSiteValue) hasData = true;
        } else if (key === "teams") {
          const teamQuestions = currentOrgQuestions.teams;
          const hasTeamValue = teamQuestions[0].values[0].details !== "";
          if (hasTeamValue) hasData = true;
        }
      });

      if (hasData) {
        emit("update:state");
      }
    }
  },
);

const getStarted = () => {
  if (isStatusApiSetup.value) {
    emit("update:state");
  }
};
</script>

<style lang="scss" scoped>
.createBtn {
  position: relative;
  z-index: 2;
  max-width: 114px;
  height: 36px;
  line-height: 22px;
}

.title__content {
  color: var(--brand-navy, #211f58);
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
}

.headingWrapper {
  padding-top: 40px;
  align-items: center;
  width: 100%;
}

.main__content {
  // background: rgba(239, 240, 241, 0.5);
}

.main {
  transition: all 0.3s ease-in-out;
  border-radius: 6px;
  border: 1px solid var(--ui-rule, #eff0f1);
  background: var(--ui-white, #fff);
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.05);
  max-width: 645px;
  margin: 0 auto;
}
</style>
